import { Banknote } from "lucide-react";
import { useLocation } from "react-router-dom";
import { InboxWithMine } from "@/pages/inbox/InboxWithMine";
import { useRegion } from "@/contexts/RegionContext";

// /collections/inbox follows the region switcher; /aus/collections/inbox is pinned to Australia (same components, region forced).
export default function AccountsInbox() {
  const { currentRegion } = useRegion();
  const { pathname } = useLocation();
  const region = pathname.startsWith("/aus/") ? "AUS" : currentRegion;
  const base = region === "AUS" ? "/aus/collections/ageing" : "/collections/ageing";
  return (
    <InboxWithMine dept="accounts" title="Accounts Inbox" icon={Banknote} testid="accounts-inbox-shell" prefix="accounts" region={region}
      storageKey="sf_accounts_inbox_view" caseLink={(c) => `${base}/${c.case_id}`} />
  );
}
